import { createSelector } from 'reselect';

const getSummary = (state) => state.transactions.summary;

export const getTransactionsSummarySelector = createSelector(
  [getSummary],
  (data) => data,
);
